// frontend/src/components/ComplexityInfo.tsx
import React from "react";

interface ComplexityInfoProps {
  complexity: {
    time: string;
    space: string;
    notes?: string;
  };
}

export const ComplexityInfo: React.FC<ComplexityInfoProps> = ({
  complexity,
}) => {
  return (
    <div className="complexity-info">
      <h4>⚡ Complexity Analysis</h4>
      <p>
        <strong>Time:</strong> {complexity.time}
      </p>
      <p>
        <strong>Space:</strong> {complexity.space}
      </p>
      {complexity.notes && (
        <p>
          <strong>Notes:</strong> {complexity.notes}
        </p>
      )}
    </div>
  );
};
